export default {};



// WEBPACK FOOTER //
// ./src/components/leaderboards/leaderboards-trophy-pyramid/leaderboards-trophy-pyramid.js